import { Component, OnInit } from "@angular/core";
import mockedAixmCatalogue from "./../mocked-aixm-catalogue.json";
import { ActivatedRoute } from "@angular/router";
import { PropertyAccessRightsComponent } from "../dialogs/property-access-rights-dialog/property-access-rights.component";
import { MatDialog } from "@angular/material/dialog";
import { BusinessRuleDialogComponent } from "../dialogs/property-business-rule/business-rule.component";
import { DataCatalogueService } from "../services/data-catalogue.service";
import { Property } from "../model/property";
import { PropertyVersion } from "../model/catalog-item";
import { PropertyViewModel } from "../model/property-view-model";

@Component({
  selector: "property-view",
  templateUrl: "./property-view.component.html",
  styleUrls: ["./property-view.component.css"],
})
export class PropertyViewComponent implements OnInit {
  propertyName: string;
  propertyId: string;
  catId: string;
  propertyGroupName: string;
  featureName: string;
  metadataExpanded: boolean = false;
  matchingProperty: any;
  property!: any;
  propertyDescription!: string;
  propertyVM!: PropertyViewModel;
  parentGroupName: string;
  propertyTypeName: string;
  propertyCount: number = 0;
  today: string;
  latestVersionNumber: number = 0;
  authorUUID: string;
  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private catalogueService: DataCatalogueService
  ) {}

  toggleMetadata(): void {
    this.metadataExpanded = !this.metadataExpanded;
  }

  findPropertyMatch(): void {
    const matchingGroup = mockedAixmCatalogue?.schema?.group?.find(
      (el) => el?._name === this.propertyGroupName
    );
    if (matchingGroup) {
      // @ts-ignore
      const matchingProperty = matchingGroup?.sequence?.element?.find(
        (el) => el?._name === this.propertyName
      );
      if (matchingProperty) {
        this.matchingProperty = matchingProperty;
      }
    }
  }

  ngOnInit() {
    this.featureName = this.route.snapshot.paramMap.get("featureId");
    this.propertyGroupName =
      this.route.snapshot.paramMap.get("propertyGroupId");
    // this.propertyName = this.route.snapshot.paramMap.get("propertyId");
    this.propertyId = this.route.snapshot.paramMap.get("propertyId");
    this.catId = this.route.snapshot.paramMap.get("catId");

    const now = new Date();
    this.today = now
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
      .toUpperCase();

    this.getProperty(this.catId, this.propertyId);
    this.loadCount();

    this.findPropertyMatch();
  }

  loadCount() {
    this.catalogueService
      .getPropertyCount(this.catId, this.propertyId)
      .subscribe((count) => {
        this.propertyCount = count;
      });
  }
  onAiracToggle(value: boolean) {
    this.propertyVM.airacRelated = value;
  }

  getProperty(catId: string, propertyId: string) {
    this.catalogueService.getPropertyMetadata(catId, propertyId).subscribe({
      next: (property: any) => {
        if (property?.name?.includes("aixm:reference_")) {
          this.propertyName = property?.name?.replace("aixm:reference_", "");
        } else {
          this.propertyName = property.name.replace(/^aixm:/, "");
        }
        const latestVersion: PropertyVersion =
          property.versions[property.versions.length - 1];

        this.latestVersionNumber = latestVersion.version;
        this.authorUUID = latestVersion.authorUUID;
        const icao = latestVersion.icao || {};

        this.propertyVM = {
          id: property.id,
          name: property.name,
          displayName:
            latestVersion.displayName.find((d) => d.lang === "en")?.text ||
            property.name,
          description:
            latestVersion.description.find((d) => d.lang === "en")?.text || "",
          airacRelated: latestVersion.airacRelated,
          propertyReference:
            latestVersion.propertyType.propertyType === "dataTypeRef"
              ? latestVersion.propertyType.uomDataTypeRef?.replace(
                  /^aixm:/,
                  "".replace("aixm:reference_", "")
                ) ?? null
              : latestVersion.propertyType.propertyType === "featureRef"
              ? latestVersion.propertyType.ref?.replace(/^aixm:/, "").replace("aixm:reference_", "") ?? null
              : latestVersion.propertyType.propertyType === "dataObjectRef"
              ? latestVersion.propertyType.ref?.replace(/^aixm:/, "").replace("aixm:reference_", "")?? null
              : null,
          author: latestVersion.author,
          timestamp: new Date(latestVersion.timestamp),

          icao: {
            accuracyValue: icao.accuracyValue,
            accuracyUom: icao.accuracyUom,
            aipResolutionValue: icao.aipResolutionValue,
            aipResolutionUom: icao.aipResolutionUom,
            chartResolutionValue: icao.chartResolutionValue,
            chartResolutionUom: icao.chartResolutionUom,
          },
        };

        this.parentGroupName = this.propertyVM.id.split("-")[0];
        this.propertyTypeName = latestVersion.propertyType.propertyType;
        console.log(latestVersion.propertyType.propertyType);
      },
      error: (err) => console.error("Error fetching property", err),
    });
  }

  openAccessRightsDialog() {
    const dialogRef = this.dialog.open(PropertyAccessRightsComponent, {
      width: "1000px",
      data: {
        propertyName: this.propertyName,
        propertyGroupName: this.parentGroupName,
        propertyId: this.propertyId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }
  openBusinessRuleDialog() {
    const dialogRef = this.dialog.open(BusinessRuleDialogComponent, {
      width: "1000px",
      height: "800px",

      data: {
        propertyName: this.propertyName,
        propertyGroupName: this.propertyGroupName,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
    });
  }
  saveMetadata(): void {
    const body: PropertyVersion = {
      propertyType: this.buildPropertyType(this.propertyTypeName),
      airacRelated: this.propertyVM.airacRelated,
      icao: {
        accuracyValue: this.propertyVM.icao.accuracyValue,
        accuracyUom: this.propertyVM.icao.accuracyUom,
        aipResolutionValue: this.propertyVM.icao.aipResolutionValue,
        aipResolutionUom: this.propertyVM.icao.aipResolutionUom,
        chartResolutionValue: this.propertyVM.icao.chartResolutionValue,
        chartResolutionUom: this.propertyVM.icao.chartResolutionUom,
      },
      version: this.latestVersionNumber,
      timestamp: new Date().toISOString(),
      author: this.propertyVM.author,
      authorUUID: this.authorUUID,
      displayName: [
        {
          lang: "en",
          text: this.propertyVM.displayName,
        },
      ],
      description: [
        {
          lang: "en",
          text: this.propertyVM.description,
        },
      ],
    };

    this.catalogueService
      .updatePropertyMetadata(this.catId, this.propertyId, body)
      .subscribe({
        next: (res) => console.log("OK:", res),
        error: (err) => console.error("PATCH ERROR:", err),
      });
  }

  private buildPropertyType(type: string): any {
    switch (type) {
      case "dataTypeRef":
        return {
          propertyType: "dataTypeRef",
        };
      case "featureRef":
        return {
          propertyType: "featureRef",
        };
      case "dataObjectRef":
        return {
          propertyType: "dataObjectRef",
        };
      default:
        throw new Error("Unknown propertyType: " + type);
    }
  }
}
